export default "__VITE_ASSET__C$idiSrd__";